import styled from 'styled-components';

import { SearchBox, SearchBoxProps } from '@components/search-box';
import { pxToRem } from '@utils/converters';
import { transitionSlow } from '@utils/transitions';

export type ExpandableSearchProps = SearchBoxProps;

export const ExpandableSearch = (props: ExpandableSearchProps) => (
  <Container>
    <SearchBox onChangeDebounce={500} placeholder="" {...props} />
  </Container>
);

const Container = styled.div({
  '.input-container:not(:focus-within)': {
    cursor: 'pointer',
  },
  '&:not(:focus-within) [data-hasvalue="false"] .input-container': {
    borderWidth: 0,
  },
  input: {
    width: 0,
    margin: 0,
    padding: 0,
    transition: transitionSlow('width'),
  },
  'input:focus, [data-hasvalue="true"] input': {
    width: pxToRem(256),
  },
  '&:not(:focus-within) [data-hasvalue="false"] .text-clear-icon': {
    width: 0,
  },
});
